import { Injectable } from '@angular/core';
const AWS = require('aws-sdk');
const AWS_ANGULAR_LOGS = require('aws-sdk');
import * as _ from 'lodash';
import * as Constants from '../models/Constants';
import { RootScopeService } from './root-scope.service';
import { InteractionEventDTO } from 'src/app/models/InteractionEventDTO';
import { Global } from '../global/globalApi';

@Injectable({
  providedIn: 'root',
})
export class AwsSqsService {
  className: string = 'AwsSqsService';
  /***
   * This service is mainly created for
   * communicating with AWS Queue and sending logs/data to AWS Queue
   * @author : Pooja Gupta
   */
  queueUrl: any;
  interactionQueueObj: any;
  constructor(public rootScope: RootScopeService) { }
  /**
   * Below method fetches out
   * aws related credentials and queue
   * data from appConfigObj and set in AWS config Obje
   */
  getAWSConfigObj() {
    try {
      // console.log(
      //   'Method updateAWSConfigObj called',
      //   this.rootScope.appConfigObj
      // );

      let accessKeyObj = this.rootScope.getObjFromConfigObj(
        Constants.AWS_SECRET_IH_KEY
      );
      let accessKeyIdObj = this.rootScope.getObjFromConfigObj(
        Constants.AWS_SECRET_IH_KEY_ID
      );
      let regionObj = this.rootScope.getObjFromConfigObj(Constants.IH_SQS_REGION);
      // Get SQS URL based on env
      // console.log('Current ENV: ' + this.getCurrentEnv());
      // let sqsEnvConst;
      // if (this.getCurrentEnv() == 'DV') {
      //   sqsEnvConst = Constants.AWS_INTERACTION_SQS_DEV;
      // } else {
      //   sqsEnvConst = Constants.AWS_INTERACTION_SQS_QA;
      // }
      this.interactionQueueObj =
        this.rootScope.getObjFromConfigObj(Constants.IH_SQS_QUEUE_URL);
      // console.log(
      //   'interactionQueueObj ' + JSON.stringify(this.interactionQueueObj)
      // );
      let queueUrlObj = this.rootScope.getObjFromConfigObj(
        Constants.IH_SQS_QUEUE_URL
      );
      let config = {
        accessKeyId: accessKeyIdObj?.['fieldValue'],
        secretAccessKey: accessKeyObj?.['fieldValue'],
        region: 'region=' + regionObj?.['fieldValue'] + '#',
      };
      console.log('AWS config Obj', config);
      this.rootScope.IH_config = {
        credentials: config,
        region: regionObj?.['fieldValue'],
      };
      // this.connectToAWSSQS(config, regionObj['fieldValue']);
      this.queueUrl = queueUrlObj?.['fieldValue'];
    } catch (e) {
      console.log('Error in fetching queue service', e);
    }
  }

  /**
   * @param :config = AWS credentials Object
   * region : "US-EAST#" .Below method is used to make connectivity
   * to amazon aws sqs using aws credentials and details
   */
  connectToAWSSQS(config, region) {
    AWS.config.update({
      credentials: config,
      region: region,
    });
  }

  loadAWSconfigForAngularLogs() {
    let regionObj = this.rootScope.getObjFromConfigObj(Constants.IH_SQS_REGION);

    let accessKeyObj = this.rootScope.getObjFromConfigObj(
      Constants.LOG_SQS_ACCESS_ID
    );
    let secretKeyObj = this.rootScope.getObjFromConfigObj(
      Constants.LOG_SECR_KEY 
    );


    let config = {
      accessKeyId: accessKeyObj?.['fieldValue'],
      secretAccessKey: secretKeyObj?.['fieldValue'],
      region: 'region=' + regionObj?.['fieldValue'] + '#',
    };

    this.rootScope.log_config = {
      credentials: config,
      region: regionObj?.['fieldValue'],
    };

    console.log('AWS Log_config' + JSON.stringify(this.rootScope.log_config));
    // AWS_ANGULAR_LOGS.config.update({
    //   credentials: config,
    //   region: regionObj['fieldValue'],
    // })

    console.log('Angular AWS config ' + JSON.stringify(config));

  }

  /**
   * sending msgs to SQS QUEUE
   */
  sendLogsToSQSQueue() {
    let params = this.createSQSQueueMsg();
    this.sendDataToSQS(params);
  }

  sendDataToSQS(data) {
    AWS.config.update(this.rootScope.IH_config);
    let sqs = new AWS.SQS({ apiVersion: '2012-11-05' });
    sqs.sendMessage(data, (err: any, data?: any) => {
        if (err) {
            this.rootScope.triggerLog("Error in sending message to SQS = "
              +JSON.stringify(err), this.className);
            console.log('Error in sending message to SQS', err);
        } else {
            this.rootScope.triggerLog("Message succesfully sent to SQS"
              +JSON.stringify(data.MessageId), this.className, Constants.DEBUG);
            console.log('Message succesfully sent to SQS', data.MessageId);
        }
    });
  }

  async sendAngularLogsToSQS(data) {
    let queueUrl = '';
    let logSQSurl = this.rootScope.getObjFromConfigObj(
      Constants.LOG_SQS_URL
    );

    if (logSQSurl) {
      queueUrl = logSQSurl['fieldValue'];
    }

    let logMsgObj = this.createAngularLogsSQSqueueMessage(data, queueUrl);
    console.log('Angular logMsgObj ' + JSON.stringify(logMsgObj));
    this.sendAngularDataToSQS(logMsgObj);
  }


  sendAngularDataToSQS(data) {
    setTimeout(() => {
      AWS_ANGULAR_LOGS.config.update(this.rootScope.log_config);
      // console.log(''this.Log_config)
      let sqs = new AWS_ANGULAR_LOGS.SQS({ apiVersion: '2012-11-05' });
      sqs.sendMessage(data, (err: any, data?: any) => {
        if (err) {
          this.rootScope.triggerLog("Error in sending message to SQS = "
            +JSON.stringify(err), this.className);
          console.log('Error in sending message to SQS', err);
        } else {
          this.rootScope.triggerLog("Angular AWS Message succesfully sent to SQS"
            +JSON.stringify(data.MessageId), this.className, Constants.DEBUG);
        //  console.log('Angular AWS Message succesfully sent to SQS', data.MessageId);
        }
      });
    }, 100);


  }

  /**
   * Below method used for testing purpose whether config object properly set
   * \in AWS or nnot
   */
  checkAWSCredentialsConfigObj() {
    AWS.config.getCredentials(function (err?: any) {
      if (err) console.log(err.stack);
      // credentials not loaded
      else {
        // console.log('Access key:', AWS.config.credentials);
      }
    });
  }

  createSQSQueueMsg() {
    return {
      DelaySeconds: 10,
      MessageAttributes: {
        'event-type': {
          DataType: 'String',
          StringValue: 'debug',
        },
        'application-type': {
          DataType: 'String',
          StringValue: 'awcp-angular',
        },
        'session-id': {
          DataType: 'String',
          StringValue: this.rootScope.sessionId,
        },
        'user-id': {
          DataType: 'String',
          StringValue: this.rootScope.userName,
        },
        'module-type': {
          DataType: 'String',
          StringValue: 'telephony',
        },
        'message-content': {
          DataType: 'String',
          StringValue: 'abcd',
        },
        'message-description': {
          DataType: 'String',
          StringValue: 'abcd',
        },
      },
      MessageBody: 'Pushing logs to SQS Queue',
      QueueUrl: this.queueUrl,
    };
  }

  createInteractionSQSQueueMsg(msgObj: InteractionEventDTO, queUrl: String) {
    //console.log('INTERACTION SQS URL: ' + queUrl);
    return {
      MessageAttributes: {
        'event-type': {
          DataType: 'String',
          StringValue: 'debug',
        },
        'application-type': {
          DataType: 'String',
          StringValue: 'awcp-angular',
        },
        'session-id': {
          DataType: 'String',
          StringValue: this.rootScope.sessionId,
        },
        'user-id': {
          DataType: 'String',
          StringValue: this.rootScope.userName,
        },
        'module-type': {
          DataType: 'String',
          StringValue: 'telephony',
        },

        agentId: {
          DataType: 'String',
          StringValue: msgObj.agentId,
        },
      },
      MessageBody: JSON.stringify(msgObj),
      // MessageDeduplicationId: new Date().getTime().toString(),
      // MessageGroupId: new Date().getTime().toString(),
      QueueUrl: queUrl,
    };
  }

  sendInteractionEventToSQS(interactionEventObj: InteractionEventDTO) {
    if (this.interactionQueueObj === undefined) {
      // console.log('sqsUrlObj for Interaction queue is Undefined');
      return;
    }
    let msgObj = this.createInteractionSQSQueueMsg(
      interactionEventObj,
      this.interactionQueueObj['fieldValue']
    );
    this.sendDataToSQS(msgObj);
  }

  sendInteractionHistoryToSQS(InteractionDTO) {
    let historyDtObj = {
      MessageAttributes: {
        'event-type': {
          DataType: 'String',
          StringValue: 'debug',
        },
        'application-type': {
          DataType: 'String',
          StringValue: 'awcp-angular',
        },
        'session-id': {
          DataType: 'String',
          StringValue: this.rootScope.sessionId,
        },
        'user-id': {
          DataType: 'String',
          StringValue: this.rootScope.userName,
        },
        'module-type': {
          DataType: 'String',
          StringValue: 'telephony',
        },

        // 'agentId': {
        //   DataType: 'String',
        //   StringValue: msgObj.agentId,
        // }
      },
      MessageBody: JSON.stringify(InteractionDTO),
      // MessageDeduplicationId: new Date().getTime().toString(),
      // MessageGroupId: new Date().getTime().toString(),
      QueueUrl: this.interactionQueueObj?.['fieldValue'],
    };

    this.sendDataToSQS(historyDtObj);
  }

  getCurrentEnv() {
    let apiUrl = `${Global.domainUrl}`;
    // console.log('getCurrentEnv apiUrl: ' + apiUrl);
    if (apiUrl?.indexOf('dv') != -1) {
      return 'DV';
    } else {
      return 'QA';
    }
  }




  createAngularLogsSQSqueueMessage(msgObj: any, queUrl: String) {
    //console.log('INTERACTION SQS URL: ' + queUrl);
    return {
      MessageAttributes: {
        'event-type': {
          DataType: 'String',
          StringValue: 'debug',
        },
        'application-type': {
          DataType: 'String',
          StringValue: 'awcp-angular',
        },
        'session-id': {
          DataType: 'String',
          StringValue: this.rootScope.sessionId,
        },
        'user-id': {
          DataType: 'String',
          StringValue: this.rootScope.userName,
        },
        'module-type': {
          DataType: 'String',
          StringValue: 'telephony',
        },

        'agentId': {
          DataType: 'String',
          StringValue: this.rootScope.lanId
        },
        'action': {
          DataType: 'String',
          StringValue: 'sendMessage'
        }
      },
      MessageBody: JSON.stringify(msgObj),
      // MessageDeduplicationId: new Date().getTime().toString(),
      // MessageGroupId: new Date().getTime().toString(),
      QueueUrl: queUrl,
    };
  }
  ''
}
